import { FC } from "react";

import { InformationBox, MuiButtonPrimary, MuiGrid } from "../..";
import { useSiteCore } from "../../../hooks/useSiteCore";
import { bulkCreateProgramSiteCoreKeys } from "../../../pages/bulkCreateProgram/siteCore/siteCoreKeys";
import { BulkInsertHeaderWrapper } from "./BulkInsertHeader.style";

interface BulkInsertHeaderProps {
  onDownloadClick?: () => void;
  isShowDownloadButton?: boolean;
  currentStep?: number;
}

export const BulkInsertHeader: FC<BulkInsertHeaderProps> = ({
  onDownloadClick,
  isShowDownloadButton,
  currentStep,
}) => {
  const { pageTitle, fetchLabel } = useSiteCore();

  const shouldShowDownloadButton = isShowDownloadButton && currentStep === 0;

  return (
    <BulkInsertHeaderWrapper>
      <MuiGrid container>
        <MuiGrid
          size={{ sm: 6, xs: 12 }}
          className="header-left"
          data-testid="bulk-transfer-header"
        >
          <InformationBox title={pageTitle} />
        </MuiGrid>

        <MuiGrid size={{ sm: 12, xs: 12 }} className="header-right">
          {shouldShowDownloadButton && (
            <MuiButtonPrimary
              onClick={onDownloadClick}
              className="header-center-button"
            >
              {fetchLabel(
                bulkCreateProgramSiteCoreKeys.bulkCreateProgram,
                bulkCreateProgramSiteCoreKeys.downloadSmartTemplateButton,
              )}
            </MuiButtonPrimary>
          )}
        </MuiGrid>
      </MuiGrid>
    </BulkInsertHeaderWrapper>
  );
};
